module.exports = __webpack_public_path__ + "img/30.49d42352.jpeg";